var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFuel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.034 15.111H.305a.3.3 0 0 0-.305.296v.297A.3.3 0 0 0 .305 16h13.729a.3.3 0 0 0 .305-.296v-.297a.3.3 0 0 0-.305-.296zM17.695 4.148h-.626c-.075-1.197-.607-2.15-1.63-2.903a.311.311 0 0 0-.428.058.29.29 0 0 0 .06.415c.873.641 1.317 1.421 1.389 2.43h-.9a.3.3 0 0 0-.306.296v2.963a.3.3 0 0 0 .305.297h1.22v3.555c0 .98-.82 1.778-1.83 1.778-1.01 0-1.83-.797-1.83-1.778V1.481C13.119.665 12.434 0 11.593 0H2.746C1.905 0 1.22.665 1.22 1.481V14.52H13.12v-1.697a2.464 2.464 0 0 0 1.83.808c1.346 0 2.44-1.064 2.44-2.37V7.703h.306A.3.3 0 0 0 18 7.407V4.444a.3.3 0 0 0-.305-.296zM5.797 9.481H3.66a.3.3 0 0 1-.305-.296.3.3 0 0 1 .305-.296h2.136a.3.3 0 0 1 .305.296.3.3 0 0 1-.305.296zm5.186-2.074a.3.3 0 0 1-.305.297H3.661a.3.3 0 0 1-.305-.297V2.37a.3.3 0 0 1 .305-.296h7.017a.3.3 0 0 1 .305.296v5.037z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuel);
export default __webpack_public_path__ + "static/media/fuel.0e76f8478b1f4776ea3dbb62a7b2c310.svg";
export { ForwardRef as ReactComponent };